// Light, friendly microcopy. Fun and warm, not joke-stuffed. Clear first.

export const taglines = [
  'another word game',
  'snatch letters, steal words',
  'spell something good',
  'words, but make it lively',
  'tap, spell, repeat',
];

export const loadingMessages = [
  'Shuffling the alphabet…',
  'Laying out the tiles…',
  'Warming up the vowels…',
  'Setting the table…',
  'Picking your letters…',
];

// Short, encouraging prompts shown when the word area is empty.
export const emptyPrompts = {
  pickLetters: 'Tap letters to spell a word',
  combine: 'Tap a word below, then add letters to make a new one',
};

// Friendly validation lines (clear about what went wrong).
export const invalidLines = {
  tooShort: 'A little longer — words need 3+ letters',
  needLonger: 'Add a letter to make it a new word',
  notAWord: "Hmm, that's not in the word list",
  sameStem: 'Make a new word, not a variation of that one',
};

export const emptyLeaderboard = 'No scores yet. Play a solo round and put your name up here.';

export function pick(list, seed) {
  if (seed === undefined) return list[Math.floor(Math.random() * list.length)];
  return list[Math.abs(seed) % list.length];
}
